import { TopicEntity } from 'src/app/models';
import { createAction } from '@ngrx/store';

export const topics = createAction(
    'TOPICS',
    (payload: TopicEntity[]) => ({payload})
);
